import Button from "app/components/Button";
import Dropdown from "app/components/Dropdown";
import DropdownIcon from "app/components/Icons/DropdownIcon";
import PlusIcon from "app/components/Icons/PlusIcon";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { actions } from "../containers/Tickets/redux/slice";
import { TicketType } from "../types";
import AddTaskModal from "./AddTaskComponent/AddTaskModal";
import { useSelector } from "react-redux";
import { selectTicketTypes } from "app/redux/selector";
import { getTicketIcon } from "../containers/Home/containers/helpers";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
import { selectTicketFormDetail } from "../containers/Tickets/redux/selector";

export default function CreateTaskButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const form = useSelector(selectTicketFormDetail);

  const handleSelect = (name: string, value) => {
    dispatch(actions.setTicketFormValue({ name: name, value: value }));
    setIsModalOpen(true);
  };
  return (
    <div className="flex flex-col">
      <div className="flex">
        <Button
          onClick={() => setIsModalOpen(true)}
          className="text-secondary !p-0 h-[42px] text-sm leading-[21px] font-normal flex flex-row items-center hover:bg-[#4288E8] !rounded-r-none"
        >
          <div className="flex flex-row items-center gap-[4px] px-[10px]">
            <PlusIcon color="#FFFFFF" />
            <span className="text-sm leading-[21px] font-normal text-white mt-[2px]">
              Task
            </span>
          </div>
        </Button>
        <CommonTicketTypeSelection
          setOpen={() => {
            setOpen(!open);
          }}
          trigger={
            <button
              className={` relative bg-primary text-white rounded-md px-4 py-2 focus:outline-none transition-all duration-300 text-secondary !p-0 h-[42px] text-sm leading-[21px] font-normal flex flex-row items-center hover:bg-[#4288E8] !rounded-l-none border-l border-[rgba(255,255,255,0.2)]${
                open ? "rotate-180" : "rotate-270"
              }
                      `}
            >
              <DropdownIcon size={20} color="#FFFFFF" />
            </button>
          }
          value={form?.type}
          setValue={(data) => {
            handleSelect("type", data?._id);
          }}
          isHeader="TICKET TYPES"
          className="!w-[200px] py-2"
          isHeaderClassName="!text-[#79808A] !text-sm !font-semibold "
          showDefault
          align="end"
        />
      </div>
      {isModalOpen && <AddTaskModal onClose={() => setIsModalOpen(false)} />}
    </div>
  );
}
